// store.js
import { configureStore } from '@reduxjs/toolkit';
import adminReducer from './adminSlice';
import supportReducer from './supportSlice';
import earlyAccessReducer from './earlyAccessSlice';

export const store = configureStore({
  reducer: {
    admin: adminReducer,
    support: supportReducer,
    earlyAccess: earlyAccessReducer,
  },
});
